<template>
  <button
    class="btn btn-transparent btn-icon btn-xs"
    @click="decreaseScale"
  >
    <i class="fal fa-minus" />
  </button>
</template>

<script>
import { useWebcamRecorder } from './use-webcam-recorder'

export default {
  name: 'WebcamRecorderDecreaseScaleButton',
  setup() {
    const { webcamScale } = useWebcamRecorder()

    const decreaseScale = () => {
      webcamScale.value = webcamScale.value - 0.1
    }

    return {
      decreaseScale,
    }
  },
}
</script>

<style scoped>

</style>
